import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import apiClient from '../../shared/services/apiService';
import API_CONFIG from '../../shared/config/api';

const AdminCompanies = () => {
  const [companies, setCompanies] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [currentCompany, setCurrentCompany] = useState(null);
  const [recordsPerPage, setRecordsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'

  // Fetch companies
  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      console.log('[Companies] Fetching from /companies...');
      const response = await apiClient.get('/companies');
      console.log('[Companies] API Response:', response);
      console.log('[Companies] Response data:', response?.data);
      
      const companiesData = response?.data?.result?.data || response?.data?.data || [];
      console.log('[Companies] Parsed companies:', companiesData);
      console.log('[Companies] Number of companies:', companiesData.length);
      
      setCompanies(companiesData);
      setFilteredCompanies(companiesData);
    } catch (err) {
      console.error('[Companies] Error fetching companies:', err);
      console.error('[Companies] Error details:', err?.response?.data);
    } finally {
      setLoading(false);
    }
  };

  // Search filter
  useEffect(() => {
    if (searchTerm) {
      const filtered = companies.filter(company =>
        company.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        company.description?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredCompanies(filtered);
    } else {
      setFilteredCompanies(companies);
    }
    setCurrentPage(1);
  }, [searchTerm, companies]);

  // Pagination
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredCompanies.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredCompanies.length / recordsPerPage);

  // Handlers
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedCompanies(currentRecords.map(company => company.id));
    } else {
      setSelectedCompanies([]);
    }
  };

  const handleSelectOne = (id) => {
    if (selectedCompanies.includes(id)) {
      setSelectedCompanies(selectedCompanies.filter(companyId => companyId !== id));
    } else {
      setSelectedCompanies([...selectedCompanies, id]);
    }
  };

  const handleViewDetails = (company) => {
    setCurrentCompany(company);
    setShowDetailModal(true);
  };

  const handleDeleteCompany = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette entreprise ?')) {
      try {
        // await apiClient.delete(`/companies/${id}`);
        setCompanies(companies.filter(company => company.id !== id));
        setSelectedCompanies(selectedCompanies.filter(companyId => companyId !== id));
      } catch (err) {
        console.error('Error deleting company:', err);
      }
    }
  };

  const handleDeleteSelected = async () => {
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer ${selectedCompanies.length} entreprise(s) ?`)) {
      try {
        setCompanies(companies.filter(company => !selectedCompanies.includes(company.id)));
        setSelectedCompanies([]);
      } catch (err) {
        console.error('Error deleting companies:', err);
      }
    }
  };

  return (
    <>
      <div className="container-fluid">
        {/* Header */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h2 className="mb-1" style={{ fontSize: '28px', fontWeight: '700' }}>Companies</h2>
                <p className="text-muted mb-0">
                  Showing {indexOfFirstRecord + 1} to {Math.min(indexOfLastRecord, filteredCompanies.length)} of {filteredCompanies.length} entries
                </p>
              </div>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item"><Link to="/admin/dashboard">Dashboard</Link></li>
                  <li className="breadcrumb-item active">Companies</li>
                  <li className="breadcrumb-item active">List</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        {/* Filters and Search */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card" style={{ borderRadius: '12px', border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-md-3">
                    <select className="form-select" style={{ borderRadius: '8px' }}>
                      <option>Choose Location</option>
                      <option>Dakar</option>
                      <option>Thiès</option>
                      <option>Saint-Louis</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <select className="form-select" style={{ borderRadius: '8px' }}>
                      <option>Salary Range</option>
                      <option>0 - 500K</option>
                      <option>500K - 1M</option>
                      <option>1M+</option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="search job title here..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{ borderRadius: '8px' }}
                    />
                  </div>
                  <div className="col-md-2">
                    <button 
                      className="btn w-100"
                      style={{
                        background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        fontWeight: '600'
                      }}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* View Controls */}
        <div className="row mb-3">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Based your preferences</h5>
              <div className="d-flex gap-2 align-items-center">
                <button
                  className={`btn btn-sm ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('list')}
                  style={{ borderRadius: '8px' }}
                >
                  <i className="fas fa-list"></i>
                </button>
                <button
                  className={`btn btn-sm ${viewMode === 'grid' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('grid')}
                  style={{ borderRadius: '8px' }}
                >
                  <i className="fas fa-th"></i>
                </button>
                <select 
                  className="form-select form-select-sm" 
                  style={{ width: 'auto', borderRadius: '8px' }}
                  value={recordsPerPage}
                  onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                </select>
                <span className="text-muted">Newest</span>
              </div>
            </div>
          </div>
        </div>

        {/* Companies Grid/List */}
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : currentRecords.length === 0 ? (
          <div className="text-center py-5">
            <p className="text-muted">Aucune entreprise trouvée</p>
          </div>
        ) : (
          <div className="row">
            {currentRecords.map((company) => (
              <div key={company.id} className={viewMode === 'grid' ? 'col-md-6 mb-4' : 'col-12 mb-3'}>
                <div 
                  className="card h-100" 
                  style={{ 
                    borderRadius: '12px', 
                    border: 'none', 
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                  }}
                >
                  <div className="card-body">
                    <div className="d-flex align-items-start">
                      {/* Logo */}
                      <div 
                        className="flex-shrink-0 me-3"
                        style={{
                          width: '80px',
                          height: '80px',
                          borderRadius: '12px',
                          overflow: 'hidden',
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        {company.logo_url?.small ? (
                          <img 
                            src={company.logo_url.small} 
                            alt={company.name}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        ) : (
                          <span style={{ fontSize: '32px', color: '#fff', fontWeight: '700' }}>
                            {company.name?.charAt(0) || 'C'}
                          </span>
                        )}
                      </div>

                      {/* Company Info */}
                      <div className="flex-grow-1">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div>
                            <h5 className="mb-1" style={{ fontWeight: '600', fontSize: '18px' }}>
                              {company.name}
                            </h5>
                            <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                              Design Team Agency
                            </p>
                          </div>
                          <button
                            className="btn btn-sm"
                            style={{
                              background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                              color: '#fff',
                              border: 'none',
                              borderRadius: '20px',
                              padding: '6px 16px',
                              fontSize: '12px',
                              fontWeight: '600'
                            }}
                          >
                            {company.posts_count || 6} Jobs Available
                          </button>
                        </div>

                        <div className="d-flex align-items-center text-muted mb-2" style={{ fontSize: '14px' }}>
                          <i className="fas fa-map-marker-alt me-2" style={{ color: '#22c55e' }}></i>
                          <span>Manchester, England</span>
                        </div>

                        {company.description && (
                          <p 
                            className="text-muted mb-0" 
                            style={{ 
                              fontSize: '13px', 
                              lineHeight: '1.5',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden'
                            }}
                          >
                            {company.description}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="d-flex gap-2 mt-3 pt-3 border-top">
                      <button
                        className="btn btn-sm btn-outline-primary flex-grow-1"
                        onClick={() => handleViewDetails(company)}
                        style={{ borderRadius: '8px' }}
                      >
                        <i className="fas fa-eye me-2"></i>View Details
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDeleteCompany(company.id)}
                        style={{ borderRadius: '8px' }}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="text-muted">
              Showing {indexOfFirstRecord + 1} to {Math.min(indexOfLastRecord, filteredCompanies.length)} of {filteredCompanies.length} entries
            </div>
            <nav>
              <ul className="pagination mb-0">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                    Previous
                  </button>
                </li>
                {[...Array(totalPages)].map((_, index) => (
                  <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(index + 1)}>
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>

      {/* Company Detail Modal */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Company Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {currentCompany && (
            <div>
              <div className="text-center mb-4">
                <div 
                  className="mx-auto mb-3"
                  style={{
                    width: '120px',
                    height: '120px',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {currentCompany.logo_url?.large ? (
                    <img 
                      src={currentCompany.logo_url.large} 
                      alt={currentCompany.name}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    <span style={{ fontSize: '48px', color: '#fff', fontWeight: '700' }}>
                      {currentCompany.name?.charAt(0) || 'C'}
                    </span>
                  )}
                </div>
                <h4>{currentCompany.name}</h4>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <strong>Email:</strong>
                  <p className="text-muted">{currentCompany.email || 'N/A'}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Phone:</strong>
                  <p className="text-muted">{currentCompany.phone || 'N/A'}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Website:</strong>
                  <p className="text-muted">
                    {currentCompany.website ? (
                      <a href={currentCompany.website} target="_blank" rel="noopener noreferrer">
                        {currentCompany.website}
                      </a>
                    ) : 'N/A'}
                  </p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Address:</strong>
                  <p className="text-muted">{currentCompany.address || 'N/A'}</p>
                </div>
                <div className="col-12 mb-3">
                  <strong>Description:</strong>
                  <p className="text-muted">{currentCompany.description || 'N/A'}</p>
                </div>
                <div className="col-12 mb-3">
                  <strong>Social Media:</strong>
                  <div className="d-flex gap-2 mt-2">
                    {currentCompany.facebook && (
                      <a href={currentCompany.facebook} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary">
                        <i className="fab fa-facebook"></i>
                      </a>
                    )}
                    {currentCompany.twitter && (
                      <a href={currentCompany.twitter} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-info">
                        <i className="fab fa-twitter"></i>
                      </a>
                    )}
                    {currentCompany.linkedin && (
                      <a href={currentCompany.linkedin} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary">
                        <i className="fab fa-linkedin"></i>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowDetailModal(false)}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AdminCompanies;
